import { render, staticRenderFns } from "./SidebarFlyout.vue?vue&type=template&id=235118cc&scoped=true"
import script from "./SidebarFlyout.vue?vue&type=script&lang=js"
export * from "./SidebarFlyout.vue?vue&type=script&lang=js"
import style0 from "./SidebarFlyout.vue?vue&type=style&index=0&id=235118cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235118cc",
  null
  
)

export default component.exports